import {useState} from 'react';

export default function RegisterScreen() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirm, setConfirm] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);

    async function handleSubmit(e) {
        e.preventDefault();
        setError('');
        if (password !== confirm) {
            setError('Passwords do not match');
            return;
        }
        try {
            const res = await fetch('/api/v1/auth/register', {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({email, password}),
            });
            if (res.status === 403) {
                setError('Registration is not allowed for this email');
                return;
            }
            if (res.status === 409) {
                setError('An account with this email already exists');
                return;
            }
            if (!res.ok) {
                setError('Registration failed. Please try again.');
                return;
            }
            setSuccess(true);
        } catch {
            setError('Registration failed. Please try again.');
        }
    }

    if (success) {
        return (
            <div className="login-screen">
                <div className="modal">
                    <h3 className="modal-title">Check your inbox</h3>
                    <p className="modal-warning">
                        Verification email sent to <strong>{email}</strong>. Click the link to activate your account.
                    </p>
                    <p className="login-register-link">
                        <a href="/?signin">Back to sign in</a>
                    </p>
                </div>
            </div>
        );
    }

    return (
        <div className="login-screen">
            <form className="register-form login-form" onSubmit={handleSubmit}>
                <h2 className="login-title">Create account</h2>
                {error ? <p className="login-error">{error}</p> : null}
                <input
                    className="login-input"
                    type="email"
                    placeholder="Email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    autoFocus
                />
                <input
                    className="login-input"
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                />
                <input
                    className="login-input"
                    type="password"
                    placeholder="Confirm password"
                    value={confirm}
                    onChange={e => setConfirm(e.target.value)}
                />
                <button
                    className="login-button"
                    type="submit"
                    disabled={!email || !password || !confirm}
                >Create account</button>
                <p className="login-register-link">
                    Already have an account? <a href="/?signin">Sign in</a>
                </p>
            </form>
        </div>
    );
}
